"use strict"

import {observable, action} from "mobx"

import api from "../../global/actions/api"

import GlobalStore from "../../global/store/GlobalStore"

class RequestStore {
	@observable data = []

	@action getRequests(form) {
		GlobalStore.loading(true, "Načítam...")

		let req = {
			filters: this.getFilters(form)
		}

		api
			.getRequests(req)
			.call()
			.then((res) => {
				if (isSafe(res) && isSafe(res.rows)) {
					this.data = res.rows
				} else {
					this.data = []
				}

				GlobalStore.loading(false)
			})
	}

	getFilters(form) {
		const values = isNotEmpty(form) ? form.values() : {}

		const filters = []

		if (isNotEmpty(values.request_number)) {
			filters.push({
				associated_column: "request_number",
				predicate: "=",
				values: [
					{
						id_value: values.request_number
					}
				]
			})
		}

		if (isNotEmpty(values.search_name_ico)) {
			filters.push({
				associated_column: "search",
				predicate: "=",
				values: [
					{
						id_value: values.search_name_ico
					}
				]
			})
		}

		if (isNotEmpty(values.request_state)) {
			filters.push({
				associated_column: "status_id",
				predicate: "=",
				values: [
					{
						id_value: values.request_state
					}
				]
			})
		}

		if (isNotEmpty(values.round)) {
			filters.push({
				associated_column: "round_id",
				predicate: "=",
				values: [
					{
						id_value: values.round
					}
				]
			})
		}

		// if (isNotEmpty(values.region)) {
		// 	filters.push({
		// 		associated_column: "region_type_id",
		// 		predicate: "=",
		// 		values: [
		// 			{
		// 				id_value: values.region
		// 			}
		// 		]
		// 	})
		// }

		// if (isNotEmpty(values.device)) {
		// 	filters.push({
		// 		associated_column: "device_id",
		// 		predicate: "=",
		// 		values: [
		// 			{
		// 				id_value: values.device
		// 			}
		// 		]
		// 	})
		// }

		return filters
	}

	@action exportData(form) {
		GlobalStore.loading(true, "Sťahujem...")
		const filters = this.getFilters(form)

		let req = {
			uri: "/gd/record/export-overview-int",
			file_name: "Zoznam ziadosti",
			filters: filters
		}

		api
			.exportData(req)
			.call()
			.then((res) => {
				if (res.ok == true) {
					let fileName = isSafe(res.headers.get("content-disposition"))
						? res.headers
								.get("content-disposition")
								.split("filename=")[1]
								.replaceAll("\"", "") // prettier-ignore
						: "export"

					res.blob().then((blob) => {
						let FileSaver = require("file-saver") // eslint-disable-line no-undef
						FileSaver.saveAs(blob, fileName)
						GlobalStore.loading(false)
					})
				} else {
					GlobalStore.loading(false)
				}
			})
			.catch(() => {
				GlobalStore.loading(false)
			})
	}

	@action exportDataFull() {
		let req = {
			uri: "/gd/record/full-export-int",
			file_name: "full-export.xlsx",
			row_count_full: 100000,
			row_count_show: 100000,
			row_offset: 1
		}

		api
			.exportData(req)
			.call()
			.then((res) => {
				if (res.ok == true) {
					let fileName = isSafe(res.headers.get("content-disposition"))
						? res.headers
								.get("content-disposition")
								.split("filename=")[1]
								.replaceAll("\"", "") // prettier-ignore
						: "Zoznam full"

					res.blob().then((blob) => {
						let FileSaver = require("file-saver") // eslint-disable-line no-undef
						FileSaver.saveAs(blob, fileName)
						GlobalStore.loading(false)
					})
				} else {
					GlobalStore.loading(false)
				}
			})
			.catch(() => {
				GlobalStore.loading(false)
			})
	}
}

var singleton = new RequestStore()
export default singleton

